import BaseApi from "./BaseApi";

export default class ClientService extends BaseApi {

    constructor(){
        super();
    }

    async list()
    {
        return this.http.get(`${this.baseUrl}/clients`)
        .catch(this.handleErrorResponse);
    }

    async get(id)
    {
        return this.http.get(`${this.baseUrl}/clients/${id}`)
        .catch(this.handleErrorResponse);
    }

    async getSelect()
    {
        return this.http.get(`${this.baseUrl}/clients/gets/getClients`)
        .catch(this.handleErrorResponse);
    }

   

    async store(data)
    {
        return this.http.post(`${this.baseUrl}/clients`, data)
        .catch(this.handleErrorResponse);
    }

    async update(id, data)
    {
        return this.http.put(`${this.baseUrl}/clients/${id}`, data)
        .catch(this.handleErrorResponse);
    }

    async delete(id)
    {
        return this.http.delete(`${this.baseUrl}/clients/${id}`)
        .catch(this.handleErrorResponse);
    }


}